import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { UserdataService } from 'src/app/services/userdata.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-bulk-suspension',
  templateUrl: './add-bulk-suspension.component.html',
  styleUrls: ['./add-bulk-suspension.component.scss']
})
export class AddBulkSuspensionComponent implements OnInit {
  form: FormGroup
  data: any = []
  dataSource: any = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "FullName",
    "Email",
    "ReferenceNumber",
    "SuspendCustomer"
  ];
  showsuspendtable = false
  showdata = false
  noDataFound: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private navigation: NavigationService,
    private userdataseriveice: UserdataService,
    private applicationdataserivce: ApplicationDataService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      searchQuery: [],
      fullName: [],
      email: [],
      refrenceNumber: [],
    })
    this.form.disable();
    this.form.controls['searchQuery'].enable();
  }

  gotobulksuspensiorevoke() {
    this.navigation.gotobulksuspensiorevoke();
    // this.navigation.getPreviousUrl();
  }

  search() {
    this.showdata = false;
    this.noDataFound = false;

    let value = this.form.getRawValue();
    if (!value.searchQuery)
      this.toastr.error("Enter a search query")


    if (value.searchQuery) {
      this.userdataseriveice.getUserDetails(value.searchQuery).subscribe((result) => {

        if (result && result.length > 0) {
          this.form.patchValue({ ...result[0] });
          this.showdata = true;
        } else {
          this.noDataFound = true;
          this.toastr.warning("Search with User Details")
        }

      });
    }
  }

  clickaction(dataField?: any) {

    // if (dataField.isSuspend === false) {
    //   dataField.isSuspend = true;
    //   this.data = [...this.data, dataField];
    // } 
    if (dataField.isSuspend === true) {
      dataField.isSuspend = false;
      this.data = this.data.filter(item => item.refrenceNumber !== dataField.refrenceNumber);
    }
    this.dataSource = new MatTableDataSource(this.data);
    this.showsuspendtable = this.data.length > 0;
    console.log(this.form.value);
  }

  suspend() {
    let value = this.form.getRawValue();
    const { searchQuery, ...rest } = value;
    const isSuspend = this.data.some(item => item.refrenceNumber === value.refrenceNumber);
    if (!isSuspend) {
      let dataField: any = {
        ...rest,
        isSuspend: true
      }
      this.showsuspendtable = true;
      this.data = [...this.data, dataField];
      this.dataSource = new MatTableDataSource(this.data);
    }
  }
  suspenduser() {
    debugger

    let emailCustomerList: any = this.data.map(item => ({ email: item.email }));
    this.applicationdataserivce.bulkSuspendSPCenter(emailCustomerList).subscribe((result) => {
      if (result == true) {
        Swal.fire('Success!!', 'Suspended successfully!', 'success')

        const txt = 'Suspended successfully!!';
        const Yes = 'OK';
        Swal.fire({
          text: txt,
          title: 'Success!!',
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#7D32DE',
          confirmButtonText: Yes,
        }).then((result) => {
          if (result.value) {
            this.navigation.gotobulksuspensiorevoke();

          }
        })
      }
      else {
        Swal.fire('Error!!', 'Unable to complete the suspension request. Kindly try again later.', 'error')
      }
    })
  }
  clearFilter() {
    this.form.controls['searchQuery'].setValue(null);
    this.showdata = false
  }
}
